import React from 'react';
import { Link } from 'react-router-dom';
import { stones } from '../mock';
import Reveal from './Reveal';
import StoneCard from './StoneCard';

const Stones = () => {
  return (
    <section id="stones" className="relative py-24 md:py-36 bg-[#FAF7F2]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <Reveal>
            <span className="section-num text-sm">03 &mdash; The Collection</span>
            <h2 className="mt-4 font-serif text-4xl md:text-5xl leading-[1.05] text-[#1a1a1a]">
              Nine stone types. <span className="italic">Infinite possibilities.</span>
            </h2>
            <p className="mt-5 max-w-2xl mx-auto text-[#4a463f] text-[15px] leading-relaxed">
              Every surface is available in a range of finishes &mdash; honed, polished, brushed, leathered.
              Explore samples from each of our nine signature stone families.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
          {stones.map((s, i) => (
            <Reveal
              key={s.name}
              delay={(i % 3) * 100}
              className={s.name === 'Sintered Stone' ? 'md:col-span-2 lg:col-span-3' : ''}
            >
              <StoneCard stone={s} index={i} />
            </Reveal>
          ))}
        </div>

        <Reveal delay={200}>
          <div className="mt-16 flex flex-col md:flex-row items-center justify-between gap-6 border-t border-[#E5DED0] pt-10">
            <p className="text-[#4a463f] text-[15px] max-w-xl">
              Looking for a specific colour, veining or finish? Browse the slabs currently in stock at our factory.
            </p>
            <Link
              to="/catalogue"
              className="btn-cherry px-8 py-4 rounded-full text-xs tracking-[0.24em] uppercase font-medium"
            >
              View Our Catalogue
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Stones;
